"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_intl_1 = require("react-intl");
var core_1 = require("@material-ui/core");
var paymentEwayStyles_1 = require("./paymentEwayStyles");
var Translation_1 = require("../../../../../../common/components/presentation/Translation/Translation");
var InitPaymentError_1 = require("../../ErrorPages/InitPaymentError");
var FailedPaymentError_1 = require("../../ErrorPages/FailedPaymentError");
var MinimalLoader_1 = require("../../../../../../common/components/presentation/MinimalLoader/MinimalLoader");
var softLockModal_1 = require("../../../../../checkout4/components/softLockModal/softLockModal");
var useJourneyStepsContext_1 = require("../../../../../checkout4/hooks/useJourneyStepsContext");
var cache_1 = require("../../../../../common/graphql/cache");
var globalTypes_1 = require("../../../../../../__generated__/globalTypes");
var useJourneyListContext_1 = require("../../../../../checkout4/context/journeys/useJourneyListContext");
var ScrollInViewTypes_1 = require("../../../../../../common/enum/ScrollInViewTypes");
var PaymentEway = function (_a) {
    var initError = _a.initError, isPaymentFailed = _a.isPaymentFailed, loading = _a.loading, paymentAmount = _a.paymentAmount, refundableState = _a.refundableState;
    var _b, _c, _d;
    var styles = paymentEwayStyles_1.default();
    var intl = react_intl_1.useIntl();
    var _e = react_1.useState(false), isVisible = _e[0], setIsVisible = _e[1];
    var changeActiveStep = useJourneyStepsContext_1.default().changeActiveStep;
    var updateJourneyList = useJourneyListContext_1.default().updateJourneyList;
    var softLockError = ((_b = initError) === null || _b === void 0 ? void 0 : _b.message) === 'trans__checkout__payment_page__out_of_stock_message';
    react_1.useEffect(function () {
        if (initError && !isVisible && !loading) {
            setIsVisible(true);
        }
    }, [initError, loading]);
    var scrollToActiveStep = function () {
        setTimeout(function () {
            document
                .querySelector("[data-test=\"checkout:step_0\"]")
                .scrollIntoView({ behavior: ScrollInViewTypes_1.ScrollInViewBehaviourType.SMOOTH, block: ScrollInViewTypes_1.ScrollInViewBlockType.CENTER });
        }, 250);
    };
    var handleSoftLockContinueBtn = function () {
        scrollToActiveStep();
        updateJourneyList(globalTypes_1.JourneyType.online_order);
        setIsVisible(false);
        cache_1.activeJourneyType(globalTypes_1.JourneyType.continue_in_dealership);
        changeActiveStep(0);
    };
    if (loading) {
        return <MinimalLoader_1.default />;
    }
    if (initError && !softLockError) {
        return <InitPaymentError_1.default />;
    }
    if (isPaymentFailed) {
        return <FailedPaymentError_1.default />;
    }
    return (<>
      <core_1.Typography data-test="text:payment:subtitle" variant="subtitle1" className={styles.subtitle}>
        <Translation_1.default id="trans__checkout__payment_page__order_online__subtitle"/>
      </core_1.Typography>
      <core_1.Typography data-test="text:payment:description" variant="subtitle1" className={styles.description}>
        <Translation_1.default id="trans__checkout__payment_page__description1" values={{
        reservationFee: paymentAmount,
        refundstate: (_d = (_c = refundableState) === null || _c === void 0 ? void 0 : _c.toLowerCase(), (_d !== null && _d !== void 0 ? _d : '')),
    }}/>
      </core_1.Typography>
      <core_1.Typography data-test="text:payment:description2" variant="subtitle1" className={styles.description2}>
        <Translation_1.default id="trans__checkout__payment_page__description2" values={{
        email: (<a className={styles.email} href={"mailto:" + intl.formatMessage({
            id: 'trans__checkout__payment_page__email',
        })}>
                <Translation_1.default id="trans__checkout__payment_page__email"/>
              </a>),
    }}/>
      </core_1.Typography>
      {isVisible && (<softLockModal_1.default isOpen={!!softLockError} onClose={function () { return setIsVisible(false); }} handleContinueBtn={handleSoftLockContinueBtn}/>)}
    </>);
};
exports.default = PaymentEway;
